





















import { Vue, Prop, Component } from 'vue-property-decorator';

import { ActivityInterface } from '@/interfaces/interfaces';
import FutsalActivity from '@/components/futsal/FutsalActivity.vue';

@Component({
  components: { FutsalActivity }
})
export default class FutsalActivities extends Vue {
  @Prop() private activities!: ActivityInterface[];

  get sortedActivities() {
    return this.activities.sort((activity) => activity.id);
  }
}
